import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\PartController::store
* @see app/Http/Controllers/Works/PartController.php:15
* @route '/works/{work}/parts'
*/
export const store = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works/{work}/parts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\PartController::store
* @see app/Http/Controllers/Works/PartController.php:15
* @route '/works/{work}/parts'
*/
store.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return store.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\PartController::store
* @see app/Http/Controllers/Works/PartController.php:15
* @route '/works/{work}/parts'
*/
store.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\PartController::store
* @see app/Http/Controllers/Works/PartController.php:15
* @route '/works/{work}/parts'
*/
const storeForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\PartController::store
* @see app/Http/Controllers/Works/PartController.php:15
* @route '/works/{work}/parts'
*/
storeForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Works\PartController::update
* @see app/Http/Controllers/Works/PartController.php:22
* @route '/works/{work}/parts/{part}'
*/
export const update = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/works/{work}/parts/{part}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Works\PartController::update
* @see app/Http/Controllers/Works/PartController.php:22
* @route '/works/{work}/parts/{part}'
*/
update.url = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            part: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        part: typeof args.part === 'object'
        ? args.part.public_id
        : args.part,
    }

    return update.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{part}', parsedArgs.part.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\PartController::update
* @see app/Http/Controllers/Works/PartController.php:22
* @route '/works/{work}/parts/{part}'
*/
update.put = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\PartController::update
* @see app/Http/Controllers/Works/PartController.php:22
* @route '/works/{work}/parts/{part}'
*/
const updateForm = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\PartController::update
* @see app/Http/Controllers/Works/PartController.php:22
* @route '/works/{work}/parts/{part}'
*/
updateForm.put = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Works\PartController::destroy
* @see app/Http/Controllers/Works/PartController.php:29
* @route '/works/{work}/parts/{part}'
*/
export const destroy = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}/parts/{part}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\PartController::destroy
* @see app/Http/Controllers/Works/PartController.php:29
* @route '/works/{work}/parts/{part}'
*/
destroy.url = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            part: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        part: typeof args.part === 'object'
        ? args.part.public_id
        : args.part,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{part}', parsedArgs.part.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\PartController::destroy
* @see app/Http/Controllers/Works/PartController.php:29
* @route '/works/{work}/parts/{part}'
*/
destroy.delete = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\PartController::destroy
* @see app/Http/Controllers/Works/PartController.php:29
* @route '/works/{work}/parts/{part}'
*/
const destroyForm = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\PartController::destroy
* @see app/Http/Controllers/Works/PartController.php:29
* @route '/works/{work}/parts/{part}'
*/
destroyForm.delete = (args: { work: string | { slug: string }, part: string | { public_id: string } } | [work: string | { slug: string }, part: string | { public_id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const parts = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default parts